import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the AiReplayProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AiReplayProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello AiReplayProvider Provider');
  }

  getAiSetting(){
    return this.http.hPost('/aireply/get_setting');
  }

  changeAiSetting(is_switch){
    return this.http.hPost('/aireply/switch',{'switch':is_switch})
  }
}



// WEBPACK FOOTER //
// ./src/providers/ai-replay/ai-replay.ts